export default __webpack_public_path__ + "static/ipo-information-53227442d62fbf08a0bdfad6063b63b8.png";